import type { RootState } from 'state';
import type { FlightCalendarsFiltersState } from '../slice';

function getAirportsFrom(state: RootState): FlightCalendarsFiltersState['airportsFrom'] {
  const { airportsFrom } = state.flightCalendars.filtersValues;
  return airportsFrom;
}

export default getAirportsFrom;
